module.exports = __webpack_public_path__ + "media/images/athletes/3433-01c77d3ef019e76397a96b4f94bac479.png";